import styled from 'styled-components';
import { fontFamilyStyles } from '../../ContentText/styles.web.js';
import { IconProfile } from '../../icons/ui_general/IconProfile.web.js';
import { px2rem } from '../../utils/helpers/style.js';
import { styles } from '../../constants/styles.js';
import { spacing } from '../../constants/spacing.js';
import { colors } from '../../constants/colors.js';

var wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-pss07c-0"
})(["display:flex;align-items:center;"]);
var buttonWrapper = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__buttonWrapper",
  componentId: "sc-pss07c-1"
})(["", ";background:none;border:none;font-size:", ";height:", ";display:flex;flex-direction:row;align-items:center;cursor:pointer;color:", ";transition:color ", ";transition-timing-function:", ";&:hover{color:", ";}"], fontFamilyStyles, px2rem(14), px2rem(80), function (props) {
  return props.$foregroundColor;
}, styles.transition.timing.slowest, styles.transition["function"].base, function (props) {
  return props.$hoverColor;
});
var textWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__textWrapper",
  componentId: "sc-pss07c-2"
})(["display:flex;flex-direction:column;padding-right:", ";align-items:flex-end;"], spacing.xxs);
var name = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__name",
  componentId: "sc-pss07c-3"
})(["text-align:right;"]);
var secondaryText = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__secondaryText",
  componentId: "sc-pss07c-4"
})(["color:", ";margin-top:", ";min-width:", ";font-size:", ";text-align:right;"], colors.sonicGrey, spacing.xxxxs, px2rem(100), px2rem(12));
var icon = /*#__PURE__*/styled(IconProfile).withConfig({
  displayName: "styles__icon",
  componentId: "sc-pss07c-5"
})(["box-sizing:content-box;color:", ";background-color:", ";border-radius:", ";padding:", ";"], function (props) {
  return props.color;
}, function (props) {
  return props.$backgroundColor;
}, function (props) {
  return px2rem(props.$size / 2 + Number(props.padding));
}, function (props) {
  return px2rem(props.padding);
});

export { buttonWrapper, icon, name, secondaryText, textWrapper, wrapper };
